// src/firebase/firebase-init.ts
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDF0E2Qj4YRf36QqGlXB1wuaRglzu4qkKc",
    authDomain: "elixir-fund.firebaseapp.com",
    projectId: "elixir-fund",
    storageBucket: "elixir-fund.firebasestorage.app",
    messagingSenderId: "1013854808734",
    appId: "1:1013854808734:web:b0b99b0c88e174f106698f",
    measurementId: "G-S4GDN0GJGM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Initialize Analytics only in production & if supported
let analytics = null;

// Only initialize analytics in production (emulators don't support analytics)
if (import.meta.env.MODE === 'production') {
  isSupported().then(supported => {
    if (supported) {
      analytics = getAnalytics(app);
      console.log('Firebase Analytics initialized');
    }
  }).catch(error => {
    console.error('Error checking Analytics support:', error);
  });
}

export { app, analytics, db, auth, storage };
